<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="updateRewardConfig.isOpen"
    id="update-reward"
  >
  <div class="mt-3 flex items-center justify-between px-6">
    <h4 class="text-2xl font-bold">Update Reward</h4>
    <feather-icon icon="XIcon" @click.stop="closeUpdateReward" class="cursor-pointer"></feather-icon>
  </div>
  <vs-divider class="mb-0"></vs-divider>

    <div class="sidebar-content p-6">
      <div class="info-form">
        <!-- <label>Reward name</label> -->
        <h4 class="text-lg font-bold m-0">Reward name</h4>
        <vs-input v-validate="'required'" name="reward_content" v-model="reward_content" class="w-full" :danger="errors.has('reward_content')"
              danger-text="The reward name field is required"/>
        <h4 class="text-lg font-bold mt-base">What is the value of offer?</h4>
        <div class="w-row">
          <ul class="centerx flex align-center justify-between">
              <vs-input-number maxlength="3" min="0" :max="max" v-model="reward_logic_value" class="w-7/12" :key="abc"/>
              <li @click="max=100,abc++">
                <vs-radio v-model="reward_logic_type" vs-value="percent" class="flex align-center m-0">%</vs-radio>
              </li>
              <li @click="max=999,abc++" class="mr-base">
                <vs-radio v-model="reward_logic_type" vs-value="usd" class="flex align-center m-0">$</vs-radio>
              </li>
          </ul>
        </div>
        <!-- <label class="mt-3 d-inline-block">Point</label> -->
        <h4 class="text-lg font-bold m-0 mt-base">Point</h4>
        <vs-input :maxlength="11" v-validate="'required'" v-on:keypress="isNumber($event)" name="reward_point" v-model="reward_point" class="w-full" :danger="errors.has('reward_point')"
              danger-text="The point field is required"/>
        <h4 class="text-lg font-bold m-0 mt-base mb-4">Change Status</h4>
          <ul class="switch-container">
            <li>
              <vs-switch v-model="reward_is_active" @click.stop="switchActive"/>
            </li>
          </ul>
      </div>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click="updateReward" style="min-width: 140px;">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeUpdateReward" style="min-width: 140px;">Cancel</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
export default {
  name: "vs-update-reward",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue")
  },
  props:{
    updateRewardConfig: {
      type: Object,
      required: true
    },
    sidebarData: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    }
  },
  data(){
    return {
      content: this.sidebarData.content,
      point: this.sidebarData.point,
      logic_type: this.sidebarData.logic_type,
      logic_value: this.sidebarData.logic_value,
      is_active: this.sidebarData.is_active,
      search: '',
      max: 100,
      abc: 0,
    }
  },
  watch:{
    updateRewardConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.content = this.sidebarData.content,
        this.point = this.sidebarData.point,
        this.logic_value = this.sidebarData.logic_value,
        this.is_active = this.sidebarData.is_active,
        this.errors.clear();

        if(this.updateRewardConfig.isOpen) {
          this.logic_type = this.sidebarData.logic_type;
          if(this.logic_type == 'usd'){
            this.max = 999;
          }else {
            this.max = 100;
          }
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    max: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.reward_logic_value > val) {
          this.reward_logic_value = val;
        }
      }
    }
  },
  computed:{
    id:{
      get(){return this.sidebarData.id},
      set(){}
    },
    reward_content:{
      get(){return this.content},
      set(value){
        this.content = value
      }
    },
    reward_point:{
      get(){return this.point},
      set(value){
        this.point = value
      }
    },
    reward_logic_type:{
       get(){return this.logic_type},
      set(value){
        this.logic_type = value
      }
    },
    reward_logic_value:{
      get(){return this.logic_value},
      set(value){
        this.logic_value = value
      }
    },
    reward_is_active:{
      get(){return this.is_active},
      set(value){
        this.is_active = value
      }
    }
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    switchActive(){
      this.is_active = this.is_active;
    },
    closeUpdateReward(){
      this.$emit("CloseUpdateReward");
    },
    updateReward(){
      if(this.reward_point == 0) {
        this.reward_point = '0';
      }
      if(this.reward_content != '' && this.reward_point != ''){
        const obj = {
          id: this.id,
          is_active: this.is_active ? 1 : 0,
          content: this.reward_content,
          point: this.reward_point,
          logic_type: this.logic_type,
          logic_value: this.logic_value,
          page: this.currentPage,
          search: this.search,
         'per-page': this.itemsPerPage,
        }
        this.$emit("UpdateReward" , obj)
      }
      this.$validator.validateAll();
    }
  },
}
</script>
